import { Form, Input } from 'antd'

const ReadOnlyTextArea = (props: {
  label: string
  value: string | undefined | null
  minRows?: number
  maxRows?: number
}) => {
  const { label, value, minRows = 3, maxRows = 5 } = props

  let content: string = value === null || value === undefined ? '' : value

  return (
    <>
      <Form layout='vertical'>
        <Form.Item label={label}>
          <Input.TextArea
            disabled={true}
            value={content}
            autoSize={value && value.length > 0 ? { minRows, maxRows } : true}
          />
        </Form.Item>
      </Form>
    </>
  )
}

export default ReadOnlyTextArea
